/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import CaseStudiesChildFooter from "./CaseStudiesChildFooter";
import ic_persons_big_circle from "../../assets/images/pictures/icon/ic_outline-peoples_big_circle-64px.svg";
import ic_search_circle from "../../assets/images/pictures/icon/ic_outline-search_circle-54px.svg";
import ic_folder_circle from "../../assets/images/pictures/icon/ic_outline-folder_shared_circle-54px.svg";
import ic_work_circle from "../../assets/images/pictures/icon/ic_outline-work_outline_circle-54px.svg";
import ic_exit_app_circle from "../../assets/images/pictures/icon/ic_exit_to_app_circle-54px.svg";
import { motion } from "framer-motion";
import routeVariants from "../../assets/animates/routeVariants";
import { useTranslation } from "react-i18next";
import Footer from "../../components/global/Footer";
import list from "../../assets/images/logos/case/doclist.png";
import cover from "../../assets/images/logos/case/cover-hr.png";
import NavbarBottom from "../../components/global/NavbarBottom";

const CaseStudiesHRContent = () => {
  const { t } = useTranslation();

  return (
    <motion.div
      variants={routeVariants}
      initial="initial"
      animate="final"
      id="content"
      className="fs-navigation-overlay-content fs-navigation-overlay-left-content fs-navigation__0 no-transform"
    >
      <header className="header--absolute"></header>

      <div className="procurement mt-50">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-10 col-sm-offset-1 header">
              <img
                className="header__ic"
                src={ic_persons_big_circle}
                alt=""
                data-no-retina=""
              />
              <h2>
                {t(
                  "case-studies-hr-page.case-studies-hr-page-content.content-1.heading"
                )}
              </h2>
              <p>
                {t(
                  "case-studies-hr-page.case-studies-hr-page-content.content-1.description"
                )}
              </p>
            </div>
            <div className="col-xs-12">
              <img className="img-responsive" src={list} alt="" />
            </div>
          </div>
          <div className="row stages mb-50">
            <div className="col-xs-12 col-sm-6 col-sm-offset-3">
              <h2>
                {t(
                  "case-studies-hr-page.case-studies-hr-page-content.content-2.heading"
                )}
              </h2>
              <p>
                {t(
                  "case-studies-hr-page.case-studies-hr-page-content.content-2.description"
                )}
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="col-sm-6 stages-hr__box">
                <img src={ic_search_circle} alt="" data-no-retina="" />
                <div className="stages-hr__box__text">
                  <h5>
                    {t(
                      "case-studies-hr-page.case-studies-hr-page-content.content-2.small-heading-1"
                    )}
                  </h5>
                  <p>
                    {t(
                      "case-studies-hr-page.case-studies-hr-page-content.content-2.small-description-1"
                    )}
                  </p>
                </div>
              </div>
              <div className="col-sm-6 stages-hr__box">
                <img src={ic_folder_circle} alt="" data-no-retina="" />
                <div className="stages-hr__box__text">
                  <h5>
                    {t(
                      "case-studies-hr-page.case-studies-hr-page-content.content-2.small-heading-2"
                    )}
                  </h5>
                  <p>
                    {t(
                      "case-studies-hr-page.case-studies-hr-page-content.content-2.small-description-2"
                    )}
                  </p>
                </div>
              </div>
              <div className="col-sm-6 stages-hr__box">
                <img src={ic_work_circle} alt="" data-no-retina="" />
                <div className="stages-hr__box__text">
                  <h5>
                    {t(
                      "case-studies-hr-page.case-studies-hr-page-content.content-2.small-heading-3"
                    )}
                  </h5>
                  <p>
                    {t(
                      "case-studies-hr-page.case-studies-hr-page-content.content-2.small-description-3"
                    )}
                  </p>
                </div>
              </div>
              <div className="col-sm-6 stages-hr__box">
                <img src={ic_exit_app_circle} alt="" data-no-retina="" />
                <div className="stages-hr__box__text">
                  <h5>
                    {t(
                      "case-studies-hr-page.case-studies-hr-page-content.content-2.small-heading-4"
                    )}
                  </h5>
                  <p>
                    {t(
                      "case-studies-hr-page.case-studies-hr-page-content.content-2.small-description-4"
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row about-pro">
            <div className="col-sm-5 pl-md-0">
              <img className="img-responsive" src={cover} alt="" />
            </div>
            <div className="col-sm-7">
              <h2>
                {t(
                  "case-studies-hr-page.case-studies-hr-page-content.content-3.heading"
                )}
              </h2>
              <p>
                {t(
                  "case-studies-hr-page.case-studies-hr-page-content.content-3.description-1"
                )}
              </p>
              <p>
                {t(
                  "case-studies-hr-page.case-studies-hr-page-content.content-3.description-2"
                )}
              </p>
              {/* <a
                className="btn-secondary"
                href="javascript:;"
                data-toggle="modal"
                data-target="#download-book"
              >
                {t(
                  "case-studies-hr-page.case-studies-hr-page-content.content-3.button-access"
                )}
              </a> */}
            </div>
          </div>
        </div>
        <CaseStudiesChildFooter />
      </div>
      <Footer />
      <NavbarBottom />
    </motion.div>
  );
};

export default CaseStudiesHRContent;
